import styled from 'styled-components';

export const Content = styled.div``;

/*
 * The cell wrapper the renderers hand back. AppTable clips it and puts the
 * full value on the cell's title, so it carries alignment and nothing else.
 *
 * Gone with the toolbar pass: the #f7f8fc / 12px-radius `Head` box (now
 * components/toolbar), the #8a93ac pill `Button`, the 40px #616e84 `Icon`
 * circle, `Title`, `Name`, `Image`, `FilterButoons` and `P` — none of which
 * this table rendered any more.
 */
export const Div = styled.div`
  &.captal {
    text-transform: capitalize;
  }
`;
